import { SET_SHOULD_RESUME_SYNC } from '../types';

const initialState = {
  status: false,
};

const shouldResumeSync = (state = initialState, action) => {
  switch (action.type) {
    case SET_SHOULD_RESUME_SYNC:
      return {
        ...state,
        status: action.status,
      };
    default:
      return state;
  }
};

export default shouldResumeSync;
